module.exports = __webpack_public_path__ + "static/media/ONE-icon.c362fdae.svg";